import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        TranslationModule,
        LandingPageSectionContainerModule,
    ],
    selector: 'app-landing-page-wagon-tracking',
    templateUrl: './wagon-tracking.component.html',
    styleUrls: ['./wagon-tracking.component.scss'],
})
export class LandingPageWagonTrackingComponent {
    useCasesLeft = [
        {
            title: 'LandingPageWagonTrackingWagonTrackingTitle',
            description: 'LandingPageWagonTrackingWagonTrackingDescription',
            icon: 'wagon-tracking',
            bulletPoints: [
                'LandingPageWagonTrackingWagonTrackingBullet1',
                'LandingPageWagonTrackingWagonTrackingBullet2',
                'LandingPageWagonTrackingWagonTrackingBullet3',
            ],
        },
        {
            title: 'LandingPageWagonTrackingIdleTimesTitle',
            description: 'LandingPageWagonTrackingIdleTimesDescription',
            icon: 'idle-times',
            bulletPoints: [
                'LandingPageWagonTrackingIdleTimesBullet1',
                'LandingPageWagonTrackingIdleTimesBullet2',
                'LandingPageWagonTrackingIdleTimesBullet3',
            ],
        },
    ]
    useCasesRight = [
        {
            title: 'LandingPageWagonTrackingGeofencesTitle',
            description: 'LandingPageWagonTrackingGeofencesDescription',
            icon: 'geofence',
            bulletPoints: [
                'LandingPageWagonTrackingGeofencesBullet1',
                'LandingPageWagonTrackingGeofencesBullet2',
                'LandingPageWagonTrackingGeofencesBullet3',
            ],
        },
        {
            title: 'LandingPageWagonTrackingHistoricMovementTitle',
            description: 'LandingPageWagonTrackingHistoricMovementDescription',
            icon: 'historic-wagon-movement',
            bulletPoints: [
                'LandingPageWagonTrackingHistoricMovementBullet1',
                'LandingPageWagonTrackingHistoricMovementBullet2',
                'LandingPageWagonTrackingHistoricMovementBullet3',
            ],
        },
    ]
}
